var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"we-view"},[_c('vue-ueditor-wrap',{attrs:{"config":_vm.myConfig,"destroy":true},on:{"ready":_vm.ready},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }